import styled from "styled-components";
import { BodyMedium, BodySmall, VerySmall } from "../typography/styled";
type ActiveProp = {
  active?:boolean,
  size?:'small' | 'display',
  containerWidth?:string,
  hover?:boolean,
  isSteps?:boolean,
  last?:any,
  greyBack?:boolean,
  $blocked?:boolean,
  $checked?:boolean,
}
export const Container = styled.div.withConfig({
  shouldForwardProp: (prop) => !['greyBack', 'isSteps'].includes(prop),
})<ActiveProp>`
  display: flex;
  width: 100%;
  min-width: 0;
  max-width: 100%;
  background-color: ${({theme, greyBack}) => greyBack ? theme.palette[10] : theme.base.white};
  align-items: flex-end;
  height:40px;
  gap:${({isSteps}) => isSteps ? '10px' : ''};
  overflow-x: ${({isSteps}) => isSteps ? 'visible' : 'auto'};
  overflow-y: hidden;
  scrollbar-width: none;
  -webkit-overflow-scrolling: touch;

  &::-webkit-scrollbar {
    display: none;
  }

  > div {
    flex: ${({isSteps}) => isSteps ? '1 1 0' : '0 0 auto'};
    min-width: ${({isSteps}) => isSteps ? '0' : 'max-content'};
  }
  /* padding: ${({size}) => size === 'small' ? '0px' : '20px 0px 0px'}; */
  &:hover{
    cursor: ${({isSteps}) => isSteps ? '' : 'pointer'};
  }

  @media (max-width: 768px) {
    height: auto;
    align-items: stretch;
    flex-direction: ${({isSteps}) => isSteps ? 'column' : 'row'};

    > div {
      flex: ${({isSteps}) => isSteps ? '1 1 auto' : '0 0 auto'};
      min-width: ${({isSteps}) => isSteps ? '0' : 'max-content'};
    }
  }
`

export const TabText = styled(BodyMedium).withConfig({
  shouldForwardProp: (prop) => !['active', 'hover', 'isSteps', 'size'].includes(prop),
})<ActiveProp>`
  color:${({theme, active, hover, isSteps}) => active ? theme.accent[100] : hover ? theme.palette[900] : theme.grey[700]};
  margin-right: ${({size, isSteps}) => isSteps ? '6px' : ''};
  overflow-wrap: anywhere;
  
`

export const TabWrapper = styled.button.withConfig({
  shouldForwardProp: (prop) => !['active', 'size', 'isSteps', 'last'].includes(prop),
})<ActiveProp>`
  appearance: none;
  flex: ${({size, isSteps}) => isSteps ? '1' : ''};;
  box-sizing: border-box;
  display: flex;
  align-items: ${({isSteps}) => isSteps ? 'flex-end' : 'center'};
  height: ${({size, isSteps}) => isSteps ? 'auto' : size === 'small' ? '36px' : '40px'};
  width: ${({size, active, $checked}) => size === 'small' && active && !$checked ? '56px' : ''};
  /* margin-right: ${({isSteps, last}) => isSteps && !last ? '10px' : ''}; */
  justify-content: ${({size, isSteps}) => !isSteps ? 'space-between' : 'flex-start'};
  padding: ${({size, isSteps}) => size === 'small' ? '0px' : isSteps ? "10px 10px 10px 0px" : '0px 20px'};
  border: 0;
  background: transparent;
  min-width: 0;
  max-width: 100%;
  border-bottom:${({active, theme, isSteps}) => {
    return isSteps ? 
    active ? `2px solid ${theme.accent[100]}` : `2px solid ${theme.grey[350]}`
    :
    active ? `2px solid ${theme.accent[100]}` : `1px solid ${theme.grey[350]}`
  }};
  cursor: ${({$blocked}) => $blocked ? 'not-allowed' : 'pointer'};
  &:focus-visible {
    border-radius: ${({theme}) => theme.radius.xs};
    outline: none;
    box-shadow: ${({theme}) => theme.isDark ? theme.shadows.focusDark : theme.shadows.focus};
  }
  /* transition:0.3s all ease-in-out; */

  @media (max-width: 768px) {
    width: ${({isSteps}) => isSteps ? '100%' : 'auto'};
    padding: ${({size, isSteps}) => size === 'small' ? '0' : isSteps ? '10px 0' : '0 14px'};
    white-space: ${({isSteps}) => isSteps ? 'normal' : 'nowrap'};
  }
`

export const DoneIndicator = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 16px;
  height: 16px;
  margin-left: 6px;
  border-radius: ${({theme}) => theme.radius.xs};
  background-color: ${({theme}) => theme.accent[100]};
  color: #FFFFFF;
  font-size: 12px;
  line-height: 16px;
`

export const NumberBadge = styled(VerySmall).withConfig({
  shouldForwardProp: (prop) => !['active', 'hover'].includes(prop),
})<ActiveProp>`
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: 20px;
  height: 20px;
  margin-left: 4px;
  padding: 0 4px;
  box-sizing: border-box;
  border-radius: ${({theme}) => theme.radius.pill};
  color: #FFFFFF;
  background-color: ${({theme, active, $blocked, hover}) => active ? theme.accent[100] : $blocked ? theme.grey[700] : hover ? theme.grey[600] : theme.isDark ? theme.palette[600] : theme.palette[800]};
`
export const AddInfoContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  padding: 10px 0px;
  gap: 10px;
  width:100%;
  border-bottom: ${({theme}) => `1px solid ${theme.grey[350]}`};
`

export const AddInfoText = styled(BodySmall).withConfig({
  shouldForwardProp: (prop) => prop !== 'active',
})<ActiveProp>`
  color:${({theme, active}) => active ? theme.primary[850] : theme.palette[700]};
`
